"use strict"

Object.assign = require("object-assign");

var keyMirror = require("keyMirror");

var Constants = keyMirror({
	SET_AUTO_ADD_STATE_AND_POSTAL_CODES: null,
	SET_AVAILABLE_MEDIA_VALUES: null,
	SET_MEDIA_OUTLET: null,
	SET_PREVIOUS_MEDIA_REQUEST: null,
	SET_SELECTED_COUNTRY: null,
	SET_SELECTED_EMAIL_TYPE: null,
	SET_SELECTED_ORGANIZATION_TYPE: null,
	SET_SELECTED_PHONE_TYPE: null,
	SET_SELECTED_STATE: null,
	SET_SELECTED_TITLE: null
});

module.exports = Constants;



// WEBPACK FOOTER //
// ./Javascript/accountComponents/AccountConstants.jsx